import { Controller } from "@hotwired/stimulus"

export default class ConfirmDialogController extends Controller {
  static targets = ["title", "message", "confirmButton"]

  open(message, messageContent, title, confirmText) {
    if (message && messageContent) {
      console.error(
        "message and messageContent params were both passed in. Only one should be used."
      )
    }

    this.#setContent(title, message, messageContent, confirmText)
    this.element.showModal()
    return new Promise((resolve) => {
      this.#createConfirmListener(resolve)
    })
  }

  #createConfirmListener(resolve) {
    this.element.addEventListener(
      "close",
      () => {
        resolve(this.element.returnValue === "confirm")
      },
      { once: true }
    )
  }

  #setContent(title, message, messageContent, confirmText) {
    this.titleTarget.textContent = title || "Confirm"
    this.confirmButtonTarget.textContent = confirmText || "Confirm"

    if (messageContent) {
      this.messageTarget.outerHTML = messageContent
    } else {
      this.messageTarget.textContent = message || "Are you sure?"
    }
  }
}
